import Info from '@/icons/info.svg';

const VARIANTS = {
	ERROR: 'error',
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning'
};

function Alert({ variant = 'info', message }) {
	return (
		<div
			className="flex items-center gap-1 rounded-lg bg-orange px-2 py-1"
			role="alert"
		>
			{variant === VARIANTS.INFO && (
				<Info aria-hidden className="size-4 text-white" />
			)}
			<div className="text-[0.625rem] font-bold leading-4 text-white">
				{message}
			</div>
		</div>
	);
}

export default Alert;
